import gql from 'graphql-tag';

export const CREATE_GUEST = gql`
  mutation guest_create {
    guest_create
  }
`;
